export enum Status {
    Active = 'Active',
    Default = 'Default',
}

export enum CategoryPortal {
    MortgagesAndSecured = 'Mortgages and Secured',
    Unsecured = 'Unsecured',
}

export enum Declaration {
    System = 'system',
    User = 'user',
}

export interface CreditCommitmentsData {
    owner?: string;
    id: number;
    primaryApplicant: boolean;
    type: string;
    outstandingBalance?: number;
    amountToConsolidate?: number;
    monthlyPayment: number;
    monthlyPaymentCustomerVerified?: number;
    status: Status;
    categoryPortal: CategoryPortal;
    consolidate?: boolean;
    ignore?: boolean;
    joint?: boolean;
    startDate?: string;
    endDate?: string;
    declaration: Declaration;
    lenderName?: string;
    interestRate?: string;
    dffDebtConSkipped?: boolean;
}

export interface DebtsToConsolidate {
    id: number;
    consolidate: boolean;
    declaration: Declaration;
}

export interface NavigationState {
    debtCon: boolean;
}
